var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isBg ? 'isbg' : 'isnobg'},[_c('div',{staticClass:"tabs-item-pc",class:_vm.on && "on",style:({fontWeight: _vm.bold ? 'bold' : '', fontSize: _vm.fontSize}),on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }